"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthoredColumns = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../table/table-cells");
const dated_columns_1 = require("../dated-evidence/dated-columns");
function useAuthoredColumns() {
    const intl = react_intl_1.useIntl();
    const { columnCreated, columnUpdated } = dated_columns_1.useDatedColumns();
    const columnCreatedBy = react_1.useMemo(() => ({
        datakey: 'createdBy',
        displaykey: 'createdBy.name',
        sortkey: 'createdBy.name',
        filterkey: 'createdBy.name',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_CREATED_BY',
            defaultMessage: 'Autor',
        }),
        width: 150,
        CellComponent: table_cells_1.TableCells.TextCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const columnUpdatedBy = react_1.useMemo(() => ({
        datakey: 'updatedBy',
        displaykey: 'updatedBy.name',
        sortkey: 'updatedBy.name',
        filterkey: 'updatedBy.name',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_UPDATED_BY',
            defaultMessage: 'Autor úpravy',
        }),
        width: 150,
        CellComponent: table_cells_1.TableCells.TextCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const authoredColumns = react_1.useMemo(() => [columnCreatedBy, columnCreated, columnUpdatedBy, columnUpdated], [columnCreatedBy, columnCreated, columnUpdatedBy, columnUpdated]);
    return {
        columnCreated,
        columnCreatedBy,
        columnUpdated,
        columnUpdatedBy,
        authoredColumns,
    };
}
exports.useAuthoredColumns = useAuthoredColumns;
//# sourceMappingURL=authored-columns.js.map